/* ─── Root ─── */

.root {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-family: var(--font-sans);
}

/* ─── Track ─── */

.track {
  flex: 1;
  height: 8px;
  background: var(--md-surface-container-highest);
  border-radius: var(--shape-full);
  overflow: hidden;
}

/* ─── Indicator ─── */

.indicator {
  height: 100%;
  border-radius: var(--shape-full);
  background: var(--status-success);
  transition: width var(--motion-duration-medium1) var(--motion-easing-standard),
    background var(--motion-duration-medium1) var(--motion-easing-standard);
}

/* ─── Semantic color levels ─── */

.indicator[data-level="low"] {
  background: var(--status-critical);
}

.indicator[data-level="medium"] {
  background: var(--status-pending);
}

.indicator[data-level="high"] {
  background: var(--status-success);
}

/* ─── Value ─── */

.value {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--md-on-surface-variant);
  white-space: nowrap;
}
